module.exports = __webpack_public_path__ + "static/media/card-mastercard.4e744bab.svg";